module.exports = __webpack_public_path__ + "img/ico1.7d81a462.svg";